<h2>{{sectionTitle}}</h2>
@if (showExpand) {
  <div (click)="expand()" (keypress)="expand()" class="collapse">
    @if (!expandAll) {
      <a tabindex="0">{{'General.ExpandAll' | translate}}</a>
    }
    @if (expandAll) {
      <a tabindex="0">{{'General.CollapseAll' | translate}}</a>
    }
  </div>
}
<div class="questions"><ng-content></ng-content></div>
